module.exports = __webpack_public_path__ + "img/like.40669428.svg";